import inputWithPlaceholder from '@PROJECT_ROOT/assets/desktop/js/search/inputWithPlaceholder';

export default function initPersons() {
    initEvents();

    inputWithPlaceholder('SearchPrivateFilterForm_persons');
    updatePersonDistributionCheckboxAccordingToPersonCount();
}

function initEvents() {
    document.getElementById('SearchPrivateFilterForm_persons').addEventListener(
        'change',
        updatePersonDistributionCheckboxAccordingToPersonCount,
    );
}

/**
 * Polje 'p_dist' omogućiti samo ako je broj osoba odabran.
 */
function updatePersonDistributionCheckboxAccordingToPersonCount() {
    const personCount = document.getElementById('SearchPrivateFilterForm_persons').value;
    document.getElementById('SearchPrivateFilterForm_p_dist').disabled = false;

    if (!Number(personCount)) {
        document.getElementById('SearchPrivateFilterForm_p_dist').disabled = true;
    }
}
